import styled from 'styled-components';
import {Person} from '@mui/icons-material';
import {COLORS, SIZES} from '@fupa/fupa-uikit';

const ProfileImageFallbackIcon = styled(Person)`
  color: ${COLORS.lightGrey};
  font-size: ${SIZES['64']};
`;

export default ProfileImageFallbackIcon;
